<template>
  <div id="app" class="app-container">
    <global-nav v-if="url != '/cloud/study'" />
    <router-view></router-view>
    <footer-nav v-if="url != '/cloud/study'"/>
  </div>
</template>

<script>
import globalNav from "./components/globalNav/index.vue";
import footerNav from "./components/footerNav.vue";
export default {
  components: {
    globalNav: globalNav,
    footerNav: footerNav,
  },
  data() {
    return {
      url: ''
    }
  },
  watch: {
    $route: {
            immediate: true,
            handler(val) {
              this.url = val.path
        }
      }
  }
};
</script>
<style lang="scss" scoped>
.app-container {
  display: flex;
  flex-direction: column;
}
</style>